define('env',['require','exports','module','environments/development','environments/test','environments/preproduction','environments/production','environments/development'],function(require, exports, module) {
  "use strict";

  var envs = {
    'landings.dev.mdirector.com': require("environments/development"),
    'landings.test.mdirector.com': require("environments/test"),
    'landings.pre.mdirector.com': require("environments/preproduction"),
    'landings.mdirector.com': require("environments/production")
  };

  var host = window.location.host;
  var env = envs[host];

  if (!env) {
    env = require("environments/development");
  }
  return env;
});

